import { useQuery } from "@tanstack/react-query";
import { fetchHashtag } from "./useHashtags";

interface Options {
	enabled?: boolean;
}

const useHashtag = (name?: string, options: Options = { enabled: true }) => {
	const query = useQuery(["hashtag", name], () => fetchHashtag(name), {
		enabled: options.enabled
	});

	return query;
};

export default useHashtag;
